// Components
import { ClearFilters } from "Components/Users/ClearFilters";
import { sentenceCase } from "change-case";
import { useDispatch } from "react-redux";
import { dynamicFormsObservationsAction } from "store/filters/reducer.actions";
import formatValue from "utils/formatValues";

interface ObservationsProps {
  name: string;
  min: number;
  max: number;
  isApplied: boolean;
}

export const Observations: React.FC<ObservationsProps> = ({
  name,
  min,
  max,
  isApplied,
}) => {
  const dispatch = useDispatch();

  const resetFilter = () => {
    dispatch(dynamicFormsObservationsAction(name, 0, 10000, false));
  };

  if (isApplied) {
    const appliedFilters = (
      <div className="flex flex-wrap justify-center items-center relative gap-1 px-2 rounded-lg bg-primary_8">
        <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative py-2">
          <p className="flex-grow-0 flex-shrink-0 text-sm text-center capitalize text-textMid dark:text-inputText  capitalize">
           {sentenceCase(name)}: {formatValue(min)} - {formatValue(max)}
          </p>
        </div>
        <ClearFilters handleClick={resetFilter} />
      </div>
    );

    return appliedFilters;
  } else {
    return null;
  }
};
